import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { PRIMARY_COLOR } from '../../styles/colors'
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { getPrivilegeStatus } from '../../util';

const MUIAccordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
}));
  
const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
      expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem', color: props.active ? '#fff' : '#000' }} />}
      {...props}
    />
  ))(({ theme, ...props }) => ({
    backgroundColor: props.active ? PRIMARY_COLOR : 'transparent',
    color: props.active ? '#fff' : '#000',
    borderRadius: '5px',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0 2rem',
    margin: 0,
    '& .MuiAccordionSummary-expandIconWrapper': {
      display: props.links == 0 ? 'none' : 'flex'  
    },
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(90deg)',

    },
}));
  
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: '5px 0 5px 15px',
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

const MenuAccordion = ({ link, active = false, user, open }) => {
    const location = useLocation()
    const [expanded, setExpanded] = useState(active);
    const [userData, setUserData] = useState(null);

    const togglePanel = () => () => {
        setExpanded(!expanded);
    };

    const getActiveLink = (link) => {
        return Boolean(location.pathname.toLowerCase().indexOf(link.toLowerCase()) > -1)
    } 

    useEffect(() => {
        setUserData(user?.userData || null)
    }, [user])

  
    return (
        <>
        {/* // <Link to={!open ? link.link : (link?.subMenus?.length > 0) ? '#' : link.link} title={link.title}> */}
            {
                Boolean(getPrivilegeStatus(link?.id) || link?.id === '') &&
                <MUIAccordion expanded={expanded} onChange={togglePanel()}>
                    <AccordionSummary active={active} links={link?.subMenus?.length || 0} style={{ borderRadius: 0 }}>
                        <Typography marginRight={'2rem'} fontSize={14}>{link.title}</Typography>
                    </AccordionSummary>
                    {
                        link?.subMenus?.length > 0 &&
                        <AccordionDetails>
                            {
                                link.subMenus.map((lnk, key) => (
                                    Boolean(getPrivilegeStatus(lnk?.id) || link?.id === '') &&
                                    <Link to={`${lnk.link}`} key={key}>
                                        <p>{lnk.title}</p>
                                    </Link>
                                ))
                            }
                        </AccordionDetails>
                    }
                </MUIAccordion>
            }
        {/* // </Link> */}
        </>
    )
};

const mapStateToProps = ({ user }) => ({ user })

export default connect(mapStateToProps, null)(MenuAccordion);
